::ng-deep app-upload-options-dialog mat-radio-button:not(:first-child){margin-top:20px}
/*# sourceMappingURL=upload-options-dialog.component-YL5RDDKM.css.map */
